import React from 'react'

const laugavegur = {
    id: 'laugavegur',
    type: 'post',
    countryId: 'iceland',
    title: 'The Laugavegur Trek',
    longDate: 'July 1, 2018',
    month: 'July',
    date: '1',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/LandmannalaugarCover.jpg',
    content: [
        {
            text: (
                <div>As soon as we decided to take this year off to travel, we knew we wanted to go back to Iceland. We’d done 6 days there in 2013, and that trip is what really sparked the travel bug. On that first trip we stayed every night in Reykjavik and did day trips around the south and west; this time, we wanted to drive around the Ring Road and do a trek through the Highlands to see the entire country.</div>
            )
        },
        {
            text: (
                <div>As far as Highlands locations go, the Laugavegur trek is both accessible and remote. Several bus companies run to the beginning, Landmannalaugar, and end, Þórsmörk. If you want to see the area and take a dip in the <a href="/post/hot-pots-of-iceland/">Landmannalaugar hot pots</a>, Iceland by Bus does a day trip starting early in the morning, stopping at both locations, and returning you to Reykjavik in the evening. It's remote in that the trail and huts are only accessible by foot; most huts were built by hikers backpacking in the building materials.</div>
            )
        },
        {
            text: (
                <div>The scenery is truly stunning. Unfortunately for us, we assumed we'd be able to charge our camera and other devices in at least Landmannalaugar, where we stayed the night before beginning our trek. This was not the case. The huts have electricity (sometimes) and a small range to cook on, but no outlets. Our camera died before we even started and we obsessively watched our phone battery levels so we could take pictures each day, turning them off most of the time so the cold didn't drain them. We met some great people on the way and Peter started a shared photo album, so many of these photos are from them!</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/LandmannalaugarUs.jpg'
        },
        {
            text: (
                <div>While you can bring a tent and camp outside the huts, the weather can be awful and we opted to book beds (we still needed to bring sleeping bags.) The huts book up months in advance, since this is the most popular trek in Iceland. We actually didn't know until the week before the trip whether or not we'd be able to go. We had booked the first week the trail is open in late June, but the opening date is contingent on the snow melting in time. Even so, all beds were taken. If you decide to go, plan it 6-9 months in advance; here's a <a href="http://frugalfrolicker.com/iceland-laugavegur-trek/">thorough post</a> and the <a href="https://www.fi.is/en/hiking-trails/laugavegur">site to book huts</a>.</div>
            )
        },
        {
            header: 'Day 1'
        },
        {
            text: (
                <div><i>Landmannalaugar to Hrafntinnusker</i></div>
            )
        },
        {
            text: (
                <div>Incredible  day: some amazingness, some good hard hiking up the mountains, and a bit of horrible time in a storm just before reaching the Hrafntinnusker hut. When we left Landmannalaugar at 9:45, it was fairly warm with clear skies. We knew there would be a few snowy parts, but the further we climbed it turned into a completely grey, snowy expanse – then started to rain and finally threw hail and high winds. We were laughing and having a good time until my foot slipped thigh-deep into ice and I was suddenly scared. Luckily 5 minutes later, we saw the hut through the storm. The people who had planned on camping frantically tried to get spots, and some decided to hike the second day's portion to get to a lower altitude and better weather.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Landmannalaugar-1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/AllSnow.jpg'
        },
        {
            text: (
                <div>After warming up, we spent the afternoon chatting and playing cards with our new Australian friends Richard, Napat, and Palin. It was a super fun internet- and phone-free evening in a snowed-in cabin (my happy place!)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Hrafntinnusker.jpg',
            detailText: 'Hrafntinnusker hut, from someone who got there before the storm.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Signpost.jpg'
        },
        {
            header: 'Day 2'
        },
        {
            text: (
                <div><i>Hrafntinnusker to Álftavatn</i></div>
            )
        },
        {
            text: (
                <div>A great day with glorious weather! We were up a little after 7 and we got out the door by 8. I think we were the first people to leave that morning, and we saw hardly anyone else on the trail except some crazy trail runners doing the entire thing in <i>one day</i>.</div>
            )
        },
        {
            text: (
                <div>Day 2 had the best scenery of our entire three weeks in Iceland. The dappled mountains were striped brown and snow white in the gentle peaks of the lowland. We descended into a valley in full springtime, with rivers glowing underfoot with the snow melt and the sun warming us. I wrote in my journal: "So glad we decided to make backpacking trips  a priority while we travel. Loving both the challenging but rewarding walks and the long evenings with ski cabin culture."</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/day2-1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/day2-2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Boys.jpg',
            detailText: 'The boys from California.'
        },
        {
            text: (
                <div>It started storming in the evening, so we knew the next day might be rough. As we would do every night while backpacking, we cooked some noodles and added water to a powdered packet of curry. Dehydrated backpacking food was astronomically expensive in the Reykjavik outdoors store, so only the people who'd purchased them in America had them and the rest of us mostly ate carbs with water. Yum.</div>
            )
        },
        {
            header: 'Day 3'
        },
        {
            text: (
                <div><i>Álftavatn to Emstrur</i></div>
            )
        },
        {
            text: (
                <div>By day 3, by far the hardest day backpacking we've ever had, here's what we'd learned about multi-day treks:
                <ul>
                        <li>If there is a chance of rain, extra socks and layers are essential, not just to swap out dirty clothes but to have dry things for the evenings and nights. </li>
                        <li>Pack more food than you think you need.</li>
                        <li>Eat a protein bar early in the hike to avoid a mental breakdown when it gets hard a few hours in.</li>
                        <li>If there are river crossings, river shoes ARE ESSENTIAL.</li>
                        <li>Don’t squabble over adding a few ounces to include useful items (flip flops, cards, first aid kit.)</li>
                        <li>You’ll get good at snot rockets quickly.</li>
                    </ul>
                </div>
            )
        },
        {
            text: (
                <div>On day 3, we had to take off our socks and shoes, rolled up our pants, and crossed a river – three times. The freezing water isn’t the problem. It’s your bare feet on sharp rocks while keeping balance with a backpack. Misery, tears, an endless expanse of flat gravel across the valley. Just had to push through this one.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/River.jpg',
            detailText: 'Peter braving the river.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/River2.jpg',
            detailText: 'Also how we felt.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Emstrur.jpg',
            detailText: 'Finally arriving at shelter.'
        },
        {
            header: 'Day 4'
        },
        {
            text: (
                <div><i>Emstrur to Þórsmörk</i></div>
            )
        },
        {
            text: (
                <div>A tall Frenchman passing the other direction scared us by saying there was another river crossing 2 kilometers into today's portion of the trek, so we resigned ourselves to wet feet the entire day. Luckily, his English was a bit off and the river wasn't until 2 kilometers from the end! I was so done with the sharp rocks that I just went through in my shoes and got them soaking.</div>
            )
        },
        {
            text: (
                <div>On the last day, we had pretty good weather and stunning views of the Mýrdalsjökull mountain range. We ran into the Australians and walked with them until the end. At this point we decided that four days was our current max for multi-day hiking; we were exhausted and ate a ton of carbs and sugar at the hut trying to recover.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/day4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/iceland/laugavegur/Thorsmork1.jpg'
        },
        {
            text: (
                <div>We had booked an extra night in Þórsmörk so we could do day hikes around the area, but our feet hurt and we spent most of the next day reading and relaxing instead.</div>
            )
        },
        {
            text: (
                <div>All in all this was an incredible experience – definitely challenging, mostly because of the weather and river crossings, but also definitely worth it.</div>
            )
        }
    ]
}


export default laugavegur



// WEBPACK FOOTER //
// ./src/Posts/Content/Laugavegur.js